import {FieldRenderProps, FieldWrapper} from "@progress/kendo-react-form"
import {TextArea} from "@progress/kendo-react-inputs"
import {FloatingLabel} from "@progress/kendo-react-labels"
import React from "react"

const TextAreaWithFloatingLabel = (fieldRenderProps: FieldRenderProps): JSX.Element => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        hint,
        disabled,
        optional,
        editorDisabled,
        onChange,
        value,
        ...others
    } = fieldRenderProps

    const [textAreaValue, setTextAreaValue] = React.useState<any>(value)
    const OnAdditonalNotesChanged = (event: any) => {
        setTextAreaValue(event.value)
        onChange({value: event.value})
    }

    return (
        <FloatingLabel className={"k-textarea-container"} label={label} editorId={id} editorValue={textAreaValue}>
            <div className={"k-form-field-wrap"}>
                <TextArea value={value} {...others} onChange={OnAdditonalNotesChanged} rows={2} />
            </div>
        </FloatingLabel>
    )
}

export default TextAreaWithFloatingLabel
